import store from "store";
import config from "@/config";
export var checkLastSubmission = function () {
    var lastSubmissionTime = store.get("".concat(config.localStoragePrefixMP, ".submissionDateTime"));
    var lastSubmissionPending = store.get("".concat(config.localStoragePrefixMP, ".submissionPending"));
    var now = new Date(Date.now() - 1000 * 60 * 5);
    if (lastSubmissionPending &&
        lastSubmissionTime &&
        now.valueOf() >
            lastSubmissionTime.valueOf()) {
        return true;
    }
    else if (lastSubmissionTime) {
        return false;
    }
    else {
        return true;
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hlY2tMYXN0U3VibWlzc2lvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNoZWNrTGFzdFN1Ym1pc3Npb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFLLE1BQU0sT0FBTyxDQUFDO0FBQzFCLE9BQU8sTUFBTSxNQUFNLFVBQVUsQ0FBQztBQUU5QixNQUFNLENBQUMsSUFBTSxtQkFBbUIsR0FBRztJQUNqQyxJQUFNLGtCQUFrQixHQUFHLEtBQUssQ0FBQyxHQUFHLENBQ2xDLFVBQUcsTUFBTSxDQUFDLG9CQUFvQix3QkFBcUIsQ0FDcEQsQ0FBQztJQUNGLElBQU0scUJBQXFCLEdBQUcsS0FBSyxDQUFDLEdBQUcsQ0FDckMsVUFBRyxNQUFNLENBQUMsb0JBQW9CLHVCQUFvQixDQUNuRCxDQUFDO0lBRUYsSUFBSSxHQUFHLEdBQUcsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLEdBQUcsRUFBRSxHQUFHLElBQUksR0FBRyxFQUFFLEdBQUcsQ0FBQyxDQUFDLENBQUM7SUFFL0MsSUFDRSxxQkFBcUI7UUFDckIsa0JBQWtCO1FBQ2xCLEdBQUcsQ0FBQyxPQUFPLEVBQUU7WUFDWCxrQkFBa0IsQ0FBQyxPQUFPLEVBQUUsRUFDOUI7UUFDQSxPQUFPLElBQUksQ0FBQztLQUNiO1NBQU0sSUFBSSxrQkFBa0IsRUFBRTtRQUM3QixPQUFPLEtBQUssQ0FBQztLQUNkO1NBQU07UUFDTCxPQUFPLElBQUksQ0FBQztLQUNiO0FBQ0gsQ0FBQyxDQUFDIn0=